
import { SearchCriteria } from "./search-criteria";

export class CancelGymMembershipModel extends SearchCriteria {

  public GymClientMembershipId: number;
}

